routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.landing', {
      url: "landing",
      template: `<landing sh-ctrl="shCtrl"></landing>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/landing/landing.config.js
 **/